// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "segment-RoaMo";
var _3 = "multiple-t9VYx";
var _4 = "flight_number-1tYbG";
var _5 = "flight_number__inner-2-rqy";
var _6 = "amenities-3BIat";
var _7 = "plane-3Jnl0";
var _8 = "time-3QXIc";
var _9 = "duration-1RyRl";
var _a = "row_last-1uf0-";
var _b = "row_first-2qnjS";
var _c = "city-1vVpM";
var _d = "route_flight-Rb2C9";
var _e = "stop-2hrdb";
var _f = "total_duration-3Xg0k";
export { _1 as "__esModule", _2 as "segment", _3 as "multiple", _4 as "flight_number", _5 as "flight_number__inner", _6 as "amenities", _7 as "plane", _8 as "time", _9 as "duration", _a as "row_last", _b as "row_first", _c as "city", _d as "route_flight", _e as "stop", _f as "total_duration" }
export default { "__esModule": _1, "segment": _2, "multiple": _3, "flight_number": _4, "flight_number__inner": _5, "amenities": _6, "plane": _7, "time": _8, "duration": _9, "row_last": _a, "row_first": _b, "city": _c, "route_flight": _d, "stop": _e, "total_duration": _f }
